//Utility
var React = require('react');

//constants
var AppConstants = require('../../constants/ApplicationConstants.js');
var BeneficiaryConstants = require('../../constants/BeneficiaryDetailsConstant.js');

//Actions
var BeneficiaryDetailsActions = require('../../actions/BeneficiaryDetailsActions.js');

//Store
var BeneficiaryDetailsStore = require('../../stores/BeneficiaryDetailsStore.js').default;
var YourDetailsStore = require('../../stores/YourDetailsStore.js');

//Components
var SectionHeader = require('../Common/SectionHeader.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var PersonalInfo  = require('../YourDetails/PersonalInfo.jsx');
var Address  = require('../YourDetails/Address.jsx');
var TelephoneNumbers = require('../Common/TelephoneNumbers.jsx');
var Email = require('../Common/Email.jsx');

function getStateFromStores() {
    return {
        model: BeneficiaryDetailsStore.getBeneficiaryModel(),
        formError: BeneficiaryDetailsStore.getFormError(),
        titleList: YourDetailsStore.getTitleList()
    };
}

var BeneficiaryDetailsSection = React.createClass({
    getInitialState: function() {
        return getStateFromStores();
    },

    componentDidMount: function() {
        BeneficiaryDetailsStore.addChangeListener(this._onChange);
    },

    componentWillUnmount: function() {
        BeneficiaryDetailsStore.removeChangeListener(this._onChange);
    },

    _onChange: function() {
        this.setState(getStateFromStores());
    },

    updateBeneficiaryModel: function(e) {
        let fieldId = e.target.model,
            value = e.target.value,
            componentId = e.target.id;

        BeneficiaryDetailsActions.updateBeneficiaryModel(fieldId, value, componentId);
    },

    render: function() {
        const Content = this.props.content,
            showNominateBeneficiary = this.state.model.isNominateBeneficiary === AppConstants.YesNoValues.YES,
            showReversionaryDetails = this.state.model.isNominateBeneficiary === AppConstants.YesNoValues.YES &&  this.state.model.type === BeneficiaryConstants.Type.REVERSIONARY;

        let beneficiaryTypeText = '';

        if(showNominateBeneficiary){
            if (this.state.model.type === BeneficiaryConstants.Type.REVERSIONARY) {

                beneficiaryTypeText = Content.beneficiaryDetails.reversionaryText;

            } else if (this.state.model.type === BeneficiaryConstants.Type.NON_LAPSING) {

                beneficiaryTypeText = Content.beneficiaryDetails.nonlapsingText;
            }
        }

        return (
            <div className="form-step">
                <SectionHeader focus={this.props.focus} sectionName={Content.beneficiaryDetails.sectionHeader} sectionHelpText={Content.common.sectionHeaderHelp} NeedHelpInfo={Content.beneficiaryDetails.sectionHelp} />

                <section className="container">

                <RadioInput id="bfyDisNominateBeneficiary"
                    data={AppConstants.YesNoRadioData}
                    value={this.state.model.isNominateBeneficiary}
                    label="Would you like to nominate a beneficiary?"
                    onChange={this.updateBeneficiaryModel}
                    model="isNominateBeneficiary"
                    errorList={this.state.formError} />

                {showNominateBeneficiary ? 
                    <RadioInput id="bfyDType"
                            data={BeneficiaryConstants.BeneficiaryTypeData}
                            value={this.state.model.type}
                            label="What type of beneficiary do you wish to nominate?"
                            onChange={this.updateBeneficiaryModel}
                            model="type"
                            contextualMessage={beneficiaryTypeText}
                            errorList={this.state.formError} />

                : null }

                {showReversionaryDetails ?
                <div>
                    <PersonalInfo section={BeneficiaryConstants.BENEFICARY}
                                  data={this.state.model}
                                  isFullNameMessageHidden={true}
                                  givenNameLabel="Given name(s)"
                                  surnameLabel="Surname"
                                  titleList={this.state.titleList}
                                  errorList={this.state.formError}
                                  onChange={this.updateBeneficiaryModel} />

                     <Address type={BeneficiaryConstants.BENEFICARY}
                              section={BeneficiaryConstants.BENEFICARY}
                              data={this.state.model}
                              errorList={this.state.formError}
                              isPostalAddressOnly={true}
                              withPostalAddress={false} />

                    <TelephoneNumbers productId={this.props.productId}
                                      mobileNumber={this.state.model.mobileNumber}
                                      homeNumber={this.state.model.homeNumber}
                                      workNumber={this.state.model.workNumber}
                                      onContactDetailsChange={this.updateBeneficiaryModel}
                                      section={BeneficiaryConstants.BENEFICARY}
                                      errorList={this.state.formError}
                                      hideWhyWeAskMobileText={true}/>

                    <Email productId={this.props.productId}
                           value={this.state.model.emailAddress}
                           onEmailChange={this.updateBeneficiaryModel}
                           mandatory={false}
                           section={BeneficiaryConstants.BENEFICARY}
                           errorList={this.state.formError} 
                           hideWhyWeAskText={true}/>

                </div>
                : null }

                </section>
            </div>
        );
     }
});

module.exports = BeneficiaryDetailsSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/BeneficiaryDetails/BeneficiaryDetailsSection.jsx